<template>
  <div class="content">
    <div class="cell">
      <div class="header">
        <div>{{ title }}</div>
        <template v-if="list.examine_status">
          <div style="color: #000" v-if="list.examine_status == 1">未审核</div>
          <div style="color: #42d885" v-else-if="list.examine_status == 2">
            已通过
          </div>
          <div style="color: red" v-else-if="list.examine_status == 3">
            驳回({{ list.reject_reason }})
          </div>
        </template>
        <div style="color: #000" v-else>未提交</div>
      </div>
      <div class="item" v-for="(item, key) in list.data" :key="key">
        <div class="name">文件名: {{ item.name }}</div>
        <div class="item_right" style="min-width: 188px">
          <div class="name">
            <el-button
              v-if="isAssetTypeAnImage(item.url)"
              size="mini"
              type="success"
              @click="preview(item)"
            >
              预览
            </el-button>
          </div>
          <div class="name">
            <el-button size="mini" type="primary">
              <a :href="item.url.replace(/http:/, 'https:')" target="_parent">
                下载
              </a>
            </el-button>
          </div>
        </div>
        <!-- <div class="name">
            <el-button size="mini" type="danger">驳回</el-button>
          </div> -->
      </div>
      <el-button size="mini" style="margin-top: 10px" v-if="isTixi">
        提醒提交
      </el-button>
      <!-- <el-divider v-if="list.examine_status != 2"></el-divider> -->
      <div class="bottom_row" v-if="list.examine_status == 1">
        <el-button size="mini" type="danger" @click="reject(list.id)"
          >驳回</el-button
        >
        <el-button
          size="mini"
          type="success"
          @click="pass(list.id)"
          :loading="passLoading"
          >通过</el-button
        >
        <!-- <el-button size="mini" type="primary" @click="batchShow=true">批量审核</el-button> -->
      </div>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  name: "Batch",
  props: {
    title: {
      type: String,
      default: "",
    },
    type: {
      type: Number,
      default: 1,
    },
    isTixi: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      passLoading: false,
    };
  },
  created() {},
  mounted() {},
  methods: {
    getUrlBase64(url) {
      return new Promise((resolve) => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        let img = new Image();
        img.crossOrigin = "Anonymous"; //允许跨域
        img.src = url;
        img.onload = function () {
          canvas.height = 300;
          canvas.width = 300;
          ctx.drawImage(img, 0, 0, 300, 300);
          let dataURL = canvas.toDataURL("image/png");
          canvas = null;
          resolve(dataURL);
        };
      });
    },
    //文件类型判断
    isAssetTypeAnImage(ext) {
      var index = ext.lastIndexOf(".");
      var ext = ext.substr(index + 1);
      return (
        ["doc", "docx", "xls", "xlsx", "ppt", "pptx", "pdf"].indexOf(
          ext.toLowerCase()
        ) !== -1
      );
    },
    judgeType(name) {
      let result = "";
      let suffix = "";
      try {
        var flieArr = name.split(".");
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = "";
      }
      let imglist = ["png", "jpg", "jpeg", "bmp", "gif", "pdf"];
      result = imglist.some(function (item) {
        return item == suffix;
      });
      return result;
    },
    preview(item) {
      let res = this.judgeType(item.url);
      if (res) {
        let routeUrl = item.url.replace(/http:/, "https:");
        window.open(routeUrl, "_blank");
      } else {
        let routeUrl = item.url;
        let officeUrl =
          "https://view.officeapps.live.com/op/view.aspx?src=" + routeUrl;
        window.open(officeUrl, "_blank");
      }
    },
    download(item) {
      console.log(item);
      let res = this.judgeType(item.file.url);
      if (res) {
        this.getUrlBase64(item.file.url).then((base64) => {
          let link = document.createElement("a");
          link.href = base64;
          link.download = item.name;
          link.click();
        });
      } else {
        let routeUrl = item.file.url.replace(/http:/, "https:");
        window.open(routeUrl + "?attname=" + item.name, "_parent");
      }
    },
    reject(id) {
      this.$prompt("请输入驳回原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          request({
            url: "/api/backend/eduAdmin/dataReject",
            method: "post",
            data: { id, reject_reason: value },
          }).then((response) => {
            this.$message({
              type: "success",
              message: "驳回成功",
            });
            this.$emit("refresh");
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    pass(id) {
      this.passLoading = true;
      request({
        url: "/api/backend/eduAdmin/dataPass",
        method: "post",
        data: { id },
      }).then((response) => {
        this.passLoading = false;
        this.$message({
          type: "success",
          message: "审核通过",
        });
        this.$emit("refresh");
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  margin-bottom: 20px;
}
.content {
  width: 50%;
  margin: 0 auto;

  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
    border-bottom: 1px solid #000;
    padding-bottom: 10px;
  }
  .cell {
    padding: 10px 20px;
    border: 1px solid #c4c4c4;
    overflow: auto;
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;
      padding-bottom: 10px;
      border-bottom: 1px solid #c4c4c4;
      flex: 1 1 auto;
      .name {
        margin-right: 15px;
      }
      .select {
        width: 20px;
        height: 20px;
      }
      .item_right {
        display: flex;
      }
    }
  }
  .bottom_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 100px;
    margin-top: 20px;
  }
  .bottom {
    display: flex;
  }
}
</style>